import { Unreachable } from '@lemon8/web-app-shared/util';
import { atom } from 'jotai';
import { PromiseOrValue } from 'shared/utils/promise-or-value';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';
import { IRelatedUserDetail } from 'shared/models';

export interface IUserRelatedUser {
  items: IRelatedUserDetail[];
  sessionImprId: string;
  hasMore: boolean;
}

type TUserRelatedUserStore = { [key: string]: PromiseOrValue<IUserRelatedUser> | undefined };

export const $UserRelatedUserStore = atom({} as TUserRelatedUserStore);

export const $UserRelatedUser = safeAtomFamily((userLinkName: string) => {
  const a = atom<PromiseOrValue<IUserRelatedUser>, [PromiseOrValue<IUserRelatedUser>], void>(
    (get) => {
      const data = get($UserRelatedUserStore)[userLinkName];
      if (!data) {
        return Unreachable('no data in $UserRelatedUser');
      }
      return data;
    },
    (get, set, input: PromiseOrValue<IUserRelatedUser>) => {
      const old = get($UserRelatedUserStore);
      set($UserRelatedUserStore, { ...old, [userLinkName]: input });
    },
  );

  a.debugLabel = `$UserRelatedUser+${encodeURIComponent(userLinkName)}`;

  return a;
});

export const $UserRelatedUserLoadmore = safeAtomFamily((userLinkName: string) => {
  const a = atom<null, [IUserRelatedUser], void>(null, async (get, set, input: IUserRelatedUser) => {
    const store = get($UserRelatedUserStore);
    const old = await store[userLinkName];

    if (old) {
      set($UserRelatedUserStore, {
        ...store,
        [userLinkName]: {
          ...input,
          items: [...old.items, ...input.items],
        },
      });
    }
  });

  a.debugLabel = `$UserRelatedUserLoadmore+${encodeURIComponent(userLinkName)}`;

  return a;
});
